import GlobalOrganizationsTable from './table/global-organizations-table';

export default function GlobalOrganizations() {
  return <GlobalOrganizationsTable />;
}
